import { render, staticRenderFns } from "./OnBoardingDialog.vue?vue&type=template&id=0fd5789e"
import script from "./OnBoardingDialog.vue?vue&type=script&lang=js"
export * from "./OnBoardingDialog.vue?vue&type=script&lang=js"
import style0 from "./OnBoardingDialog.vue?vue&type=style&index=0&id=0fd5789e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports